import { Box, Button, SvgIcon } from '@mui/material';
import CopyIcon from 'assets/icons/copy.svg';
import copy from 'copy-to-clipboard';
import PropTypes, { element, func, object, string } from 'prop-types';
import React, { useCallback } from 'react';
import { I18n } from 'utils/i18n';

const CopyButton = rawProps => {
  const props = { variant: 'outlined', color: 'secondary', ButtonProps: {}, ...rawProps };
  const { value, text, variant, color, ButtonProps, inputRef } = props;
  const handleClick = useCallback(() => {
    if (value !== undefined) {
      copy(value);
    } else if (inputRef?.current !== undefined) {
      copy(inputRef.current.value);
    }
  }, [inputRef, value]);
  return (
    <Box sx={{ display: 'flex' }}>
      <Button variant={variant} color={color} onClick={handleClick} {...ButtonProps}>
        <SvgIcon sx={{ fontSize: 18, marginRight: '5px', color: 'primary.main' }}>
          <CopyIcon />
        </SvgIcon>
        {typeof text === 'undefined' ? I18n.t('CopyField.Copy') : text}
      </Button>
    </Box>
  );
};

CopyButton.propTypes = {
  value: string.isRequired,
  text: string,
  variant: string,
  ButtonProps: object,
  color: string,
  inputRef: PropTypes.oneOfType([
    // Either a function
    func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(element) }),
  ]),
};

export default CopyButton;
